import { render, staticRenderFns } from "./MoreButton.vue?vue&type=template&id=3088fb2a&scoped=true&"
import script from "./MoreButton.vue?vue&type=script&lang=ts&"
export * from "./MoreButton.vue?vue&type=script&lang=ts&"
import style0 from "./MoreButton.vue?vue&type=style&index=0&id=3088fb2a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3088fb2a",
  null
  
)

export default component.exports